
































































































import { defineComponent, computed } from "@nuxtjs/composition-api";

export default defineComponent({
  name: "OrderTotals",
  props: {
    orderData: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const orderDetail = computed(() => props.orderData || {});
    const items = computed(() => props.orderData?.items || []);
    const totalOriginalPrice = computed(() => {
      return items.value.reduce(
        (sum, item) => sum + (item.original_price * item.qty_ordered || 0),
        0
      );
    });
    const discountPrice = computed(() => {
      return totalOriginalPrice.value - (props.orderData?.subtotal || 0);
    });

    return {
      orderDetail,
      totalOriginalPrice,
      discountPrice,
    };
  },
});
